import React from 'react';
import { Box } from '@wix/design-system';
import { InfoLine } from './InfoLine';
export const InfoSection = ({ title, subtitle, content, ...rest }) => {
    const filteredContent = content
        .filter(Boolean)
        .map((subContent) => subContent?.toString());
    const renderTitle = () => {
        if (!title) {
            return undefined;
        }
        return (React.createElement(InfoLine, { clearPadding: true, weight: "bold" }, title));
    };
    const renderSubtitle = () => {
        if (!subtitle) {
            return undefined;
        }
        return (React.createElement(InfoLine, { clearPadding: !title, weight: "bold" }, subtitle));
    };
    const renderContent = () => {
        return filteredContent.map((subContent, index) => (React.createElement(InfoLine, { key: `SubContent_${index}`, clearPadding: index === 0 && !title }, subContent)));
    };
    if (!title && !subtitle && filteredContent.length === 0) {
        return null;
    }
    return (React.createElement(Box, { direction: "vertical", ...rest },
        renderTitle(),
        renderSubtitle(),
        renderContent()));
};
//# sourceMappingURL=InfoSection.js.map